import { motion } from '@hover/blueprint/foundation';
import { Box, BoxProps, Icon, Divider, Body } from '@hover/blueprint';
import { iX } from '@hover/icons';
import React from 'react';

interface Props extends BoxProps {
  title: string;
  content: string | React.ReactNode;
  isExpanded: boolean;
  onClick: () => void;
}

const ButtonWrapper: React.FC<BoxProps> = ({ children, ...rest }) => (
  <>
    <Box
      _hover={{ backgroundColor: 'primary.100' }}
      d={{ base: 'none', desktop: 'flex' }}
      {...rest}
    >
      {children}
    </Box>
    <Box
      as="button"
      aria-label="open-close"
      _focus={{ backgroundColor: 'primary.100' }}
      d={{ base: 'flex', desktop: 'none' }}
      {...rest}
    >
      {children}
    </Box>
  </>
);

const Accordion: React.FC<Props> = ({
  title,
  content,
  isExpanded,
  onClick,
  ...rest
}) => (
  <Box w="100%" flexDir="column" overflow="hidden" {...rest}>
    <Box
      as="button"
      aria-expanded={isExpanded}
      onClick={onClick}
      cursor="pointer"
      w="100%"
      flexDir="row"
      alignItems="center"
      justifyContent="flex-start"
      pt={500}
      pb={400}
      pl={100}
      aria-controls={`accordion-panel-${title}`}
      id={`accordion-header-${title}`}
    >
      <ButtonWrapper
        borderRadius="50%"
        mr={400}
        minW={300}
        w={300}
        h={300}
        justifyContent="center"
        alignItems="center"
      >
        <Icon
          m={0}
          icon={iX}
          transform={`rotateZ(${isExpanded ? 0 : '45deg'})`}
          transition={`all ${motion.easings[250]}`}
          size="small"
        />
      </ButtonWrapper>
      <Body size={{ base: 500, desktop: 600 }} isSemiBold>
        {title}
      </Body>
    </Box>
    <Box
      aria-hidden={!isExpanded}
      aria-labelledby={`accordion-header-${title}`}
      id={`accordion-panel-${title}`}
      mt={200}
      maxH={isExpanded ? '1000px' : 0}
      transition="all 0.4s ease"
      pl={700}
      overflow="hidden"
    >
      {content}
    </Box>
    <Divider
      borderColor="neutral.500"
      my={0}
      borderWidth="1px"
      borderTopWidth={0}
    />
  </Box>
);

export default Accordion;
